import { inject, injectable } from 'inversify';
import SlackNotificationsService from 'src/features/slack/data/service/SlackNotificationsService';
import { SendSlackMessageRequest } from 'src/features/slack/data/service/SlackNotificationsService.types';
import { SlackNotificationsRepositoryInterface } from 'src/features/slack/domain/SlackNotificationsRepositoryInterface';

@injectable()
class SlackNotificationsRepository
  implements SlackNotificationsRepositoryInterface
{
  @inject(SlackNotificationsService)
  private slackNotificationsService!: SlackNotificationsService;

  async send(params: SendSlackMessageRequest) {
    const response = await this.slackNotificationsService.send(params);

    return response.data;
  }
}

export default SlackNotificationsRepository;
